import script from "./CustomerDistributionSlot.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDistributionSlot.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDistributionSlot.vue?vue&type=style&index=0&id=05d2bc41&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d2bc41"]])

export default __exports__